interface RankItem {
  rank: number;
  title: string;
  category: string;
  hot: string;
}

const rankingItems: RankItem[] = [
  { rank: 1, title: '庆余年第三季', category: '古装权谋', hot: '🔥 1.2亿' },
  { rank: 2, title: '玫瑰的故事', category: '都市情感', hot: '🔥 9,800万' },
  { rank: 3, title: '长相思 第二季', category: '仙侠奇幻', hot: '🔥 8,500万' },
  { rank: 4, title: '墨雨云间', category: '古装悬疑', hot: '🔥 7,200万' },
  { rank: 5, title: '承欢记', category: '家庭伦理', hot: '📈 6,100万' },
  { rank: 6, title: '与凤行', category: '仙侠爱情', hot: '📈 5,400万' },
  { rank: 7, title: '狐妖小红娘·月红篇', category: '国漫改编', hot: '📈 4,800万' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            热播榜单
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">本周热播TOP7 · 大家都在追</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            实时热度排行，看看全网观众都在看什么好剧。
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors duration-150 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center shrink-0 ${
                item.rank === 1 ? 'bg-accent-500' : item.rank === 2 ? 'bg-primary-500' : item.rank === 3 ? 'bg-secondary-500' : 'bg-background-200'
              }`}>
                <span className={`text-sm md:text-base font-extrabold ${
                  item.rank <= 3 ? 'text-background-50' : 'text-foreground-600'
                }`}>
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <span className="text-xs md:text-sm font-semibold text-accent-600 whitespace-nowrap shrink-0">{item.hot}</span>
              <div className="w-8 h-8 flex items-center justify-center shrink-0 text-foreground-400">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}